const COLUMNS = [
  {
    title: "Product",
    links: ["Overview", "Front Desk", "Sales", "Billing", "Support"],
  },
  {
    title: "Solutions",
    links: ["Small Business", "Agencies", "Services", "Retail", "Startups"],
  },
  {
    title: "Company",
    links: ["About", "Careers", "Contact", "Press"],
  },
  {
    title: "Resources",
    links: ["Blog", "Guides", "Help Center", "API Docs"],
  },
  {
    title: "Legal",
    links: ["Privacy", "Terms", "Security", "DPA"],
  },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-nova-navy text-white">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 pt-20 pb-10">
      <div className="grid lg:grid-cols-[1.3fr_2fr] gap-14">
        <div>
          <a href="#top" data-testid="brand-logo" className="inline-block">
            <img
              src="/nova-logo-footer.png"
              alt="NOVA OPSIS — A New Way Forward."
              className="w-44 select-none"
              draggable={false}
            />
          </a>
          <p className="mt-6 text-sm text-slate-400 leading-relaxed max-w-xs">
            The intelligent operational layer for small and growing businesses.
          </p>
          <div className="mt-7 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-2">
            <span className="relative flex w-2 h-2">
              <span className="absolute inline-flex w-full h-full rounded-full bg-emerald-400 animate-pulse-dot" />
              <span className="relative inline-flex w-2 h-2 rounded-full bg-emerald-400" />
            </span>
            <span className="text-[11px] font-semibold text-slate-300 tracking-wide">
              Nova is working
            </span>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-8">
          {COLUMNS.map((col) => (
            <div key={col.title}>
              <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-slate-500">
                {col.title}
              </p>
              <ul className="mt-5 space-y-3">
                {col.links.map((l) => (
                  <li key={l}>
                    <a
                      href="#top"
                      data-testid={`footer-link-${l.toLowerCase().replace(/\s+/g, "-")}`}
                      className="text-sm text-slate-400 hover:text-white transition-colors duration-300"
                    >
                      {l}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-xs text-slate-500">
          © 2026 Nova Opsis. All rights reserved.
        </p>
        <p className="text-[10px] font-semibold tracking-[0.32em] text-nova-blue">
          A NEW WAY FORWARD.
        </p>
      </div>
    </div>
  </footer>
);
